import { useEffect } from 'react';
import { useApplicationContext } from '../../../ApplicationContext';

export const usePaymentEvents = () => {
  const { microfrontendsApi } = useApplicationContext();

  const handlePay = (e: CustomEvent) => {
    microfrontendsApi?.buyPackage(e.detail);
  };

  const handlePaymentSuccess = (e: CustomEvent) => {
    if (e.detail.confirmationToken) {
      const paymentToken = e.detail.confirmationToken.substring(3);

      microfrontendsApi?.checkPaymentStatus(paymentToken);
    } else {
      microfrontendsApi?.loadPublishTerms();
    }
  };

  useEffect(() => {
    window.addEventListener('service-picker-widget/buy-package', handlePay);
    window.addEventListener('payment-success', handlePaymentSuccess);

    return () => {
      window.removeEventListener('service-picker-widget/buy-package', handlePay);
      window.removeEventListener('payment-success', handlePaymentSuccess);
    };
  });
};
